import styled from "styled-components";
import { SearchField as SearchFieldUI } from "@evergis/ui";

import { SearchProps } from "./types";

export const SearchFieldContainer = styled.div<SearchProps>`
  max-width: ${({ maxWidth }) => maxWidth || "22.5rem"};
  width: ${({ width }) => width || "100%"};
  min-width: ${({ minWidth }) => minWidth || "12.5rem"};
`;

export const SearchField = styled(SearchFieldUI)<SearchProps>`
  max-width: ${({ maxWidth }) => maxWidth || "22.5rem"};
  min-width: ${({ minWidth }) => minWidth || "12.5rem"};
`;

export const CategoryBlockExpanded = styled.div`
  @media screen and (max-width: 48.75rem) {
    display: none;
  }
`;

export const CategoryBlockCollapsed = styled.div`
  margin-right: 1rem;
  @media screen and (min-width: 48.75rem) {
    display: none;
  }
`;
